import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import {
  addACPackagedPackagedSub,
  editACPackagedPackagedSub,
  removeACPackagedPackagedSub,
} from '../../redux/ac_packaged_unit/ac_packaged_unit_actions';
import { searchACPackagedSubByText } from '../../redux/ac_packaged_unit/ac_packaged_sub_actions';
import { defaultRejectHandler } from '../../utils/utility';

export class PackagedSubDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'packaged_sub.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'packaged_sub.name',
        ...textColumn,
        entity: {
          list: text => searchACPackagedSubByText(text)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'packaged_sub.power_required',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {
      isShowCreateAC: false,
    };
  }

  render() {
    const {
      categoryOption,
      selectedItem: item,
    } = this.state;

    const {
      acPackagedId,
      filtered,
      filteredCount,
      isLoading,
      addACPackagedPackagedSub,
      editACPackagedPackagedSub,
      removeACPackagedPackagedSub,
      isACPackagedSubAdding,
      isACPackagedSubEditing,
      isACPackagedSubRemoving,
      t,
    } = this.props;

    const relationship = {
      create: ({ entityId, quantity }) => addACPackagedPackagedSub(acPackagedId, entityId, quantity),
      edit: ({ id, quantity }) => editACPackagedPackagedSub(id, quantity),
      delete: id => removeACPackagedPackagedSub(id, acPackagedId),
      isCreating: isACPackagedSubAdding,
      isEditing: isACPackagedSubEditing,
      isDeleting: isACPackagedSubRemoving,
    };

    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>
          <RelationDataTable
            columns={this.columns}
            data={this.props.packagedSubs}
            relationship={relationship}
            relationshipNameAccessor={item => item.packaged_sub.name}
            classNamePrefix="select-air-conditioning-package-sub"
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isACPackagedSubAdding: state.ac.packagedUnit.isACPackagedSubAdding,
  isACPackagedSubEditing: state.ac.packagedUnit.isACPackagedSubEditing,
  isACPackagedSubRemoving: state.ac.packagedUnit.isACPackagedSubRemoving,
});

const mapDispatchToProps = dispatch => ({
  addACPackagedPackagedSub: (acPackagedId, packagedSubId, quantity) => defaultRejectHandler(dispatch(addACPackagedPackagedSub(acPackagedId, packagedSubId, quantity))),
  editACPackagedPackagedSub: (acPackagedPackagedSubId, quantity) => defaultRejectHandler(dispatch(editACPackagedPackagedSub(acPackagedPackagedSubId, quantity))),
  removeACPackagedPackagedSub: (acPackagedPackagedSubId, acPackagedId) => defaultRejectHandler(dispatch(removeACPackagedPackagedSub(acPackagedPackagedSubId, acPackagedId)))
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(PackagedSubDataTable),
);



// WEBPACK FOOTER //
// ./src/components/ac_packaged_unit/PackagedSubDataTable.js